import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { VoucherPostingLogic } from './voucher-list/voucherposting-view.service';

export class VoucherPostingForm extends CerFormAdapter {
 
  override viewSetInit(viewSet: CerFormViewSet): void {
    const view = VoucherPostingLogic.viewGet(true,  true);
    
    viewSet.viewAdd(view);
 }
}
